module.exports = __webpack_public_path__ + "img/chd-gj-5.67186cb9.png";